import React from 'react';
import axios from 'axios';
import { Modal, Form, Input, Checkbox, Button, Space, InputNumber, Select, Divider, Row, Col, Radio, Spin } from 'antd';
import { layout, tailLayout, formStyle } from 'containers/common/layout';
import TextArea from 'antd/lib/input/TextArea';

interface IProps {
    dataId: number,
    editorVisible: boolean,
    editorTitle: string,
    onCancel: any,
}

const { Option } = Select;

class ExtraEdit extends React.Component<IProps> {
    lastFetchId: number;
    constructor(props: any) {
        super(props);
        this.lastFetchId = 0;
    }

    state = {
        visible: false,
        priceType: "a",
        data: [],
        value: [],
        fetching: false
    };

    fetchUser = (value: any) => {
        this.lastFetchId += 1;
        const fetchId = this.lastFetchId;
        this.setState({ data: [], fetching: true });
        axios.get('https://www.fastmock.site/mock/9973669a2a13cbb70690fdf6f1880e97/admin/extra/list', {
            params: {}
        })
            .then((res) => {
                console.log('res', res.data.data.list)
                if (fetchId !== this.lastFetchId) {
                    // for fetch callback order
                    return;
                }
                const data = res.data.data.list.map((extra: { name: any; id: any; }) => ({
                    text: `${extra.name}`,
                    value: extra.id,
                }));
                this.setState({ data, fetching: false });
            })
            .catch((err) => {
                console.log(err)
            })
    }

    cancelModal = () => {
        this.props.onCancel();
    }

    onFinish = (values: any) => {
        console.log('Success:', values);
    };

    onFinishFailed = (errorInfo: any) => {
        console.log('Failed:', errorInfo);
    };

    priceTypeChange = (e: any) => {
        this.setState({
            priceType: e.target.value
        })
    }

    render() {
        return (
            <div>
                <Modal
                    title={this.props.editorTitle}
                    visible={this.props.editorVisible}
                    onCancel={this.cancelModal}
                    footer={null}
                    destroyOnClose={true}
                    maskClosable={false}
                    width={1000}
                >
                    <Form
                        name="basic"
                        initialValues={{ remember: true }}
                        onFinish={this.onFinish}
                        onFinishFailed={this.onFinishFailed}
                        size="large"
                        style={formStyle}
                    >
                        <Row gutter={[18, 4]}>
                            <Col span={16}>
                                <Form.Item
                                    label="资源名称"
                                    name="name"
                                    rules={[{ required: true, message: 'Please input!' }]}
                                    labelCol={{ span: 6 }}
                                >
                                    <Input allowClear />
                                </Form.Item>
                            </Col>
                            <Col span={8}>
                                <Form.Item
                                    label="分类"
                                    name="reasonType"
                                    rules={[{ required: true, message: 'Please select!' }]}
                                    labelCol={{ span: 8 }}
                                >
                                    <Select
                                        style={{ width: '100%' }}
                                    >
                                        <Option value="1">天气原因</Option>
                                        <Option value="2">行程有变</Option>
                                        <Option value="3">态度问题</Option>
                                    </Select>
                                </Form.Item>
                            </Col>
                            <Col span={12}>
                                <Form.Item
                                    label="计价单位"
                                    name="priceType"
                                    rules={[{ required: true, message: 'Please select!' }]}
                                    labelCol={{ span: 8 }}
                                >
                                    <Radio.Group
                                        defaultValue={this.state.priceType}
                                        size="large"
                                        onChange={this.priceTypeChange}
                                    >
                                        <Radio.Button value="a">按数量</Radio.Button>
                                        <Radio.Button value="b">按人数</Radio.Button>
                                    </Radio.Group>
                                </Form.Item>
                            </Col>

                            {
                                this.state.priceType == 'a' &&
                                <Col span={6}>
                                    <Form.Item
                                        label="单位价格"
                                        name="price"
                                        rules={[{ required: true, message: 'Please input!' }]}
                                        labelCol={{ span: 10 }}
                                    >
                                        <InputNumber style={{ width: "100%" }} />
                                    </Form.Item>
                                </Col>
                            }

                            {
                                this.state.priceType == 'b' &&
                                <Col span={6}>
                                    <Form.Item
                                        label="成人价格"
                                        name="priceAdult"
                                        rules={[{ required: true, message: 'Please input!' }]}
                                        labelCol={{ span: 10 }}
                                    >
                                        <InputNumber style={{ width: "100%" }} />
                                    </Form.Item>
                                </Col>
                            }

                            {
                                this.state.priceType == 'b' &&
                                <Col span={6}>
                                    <Form.Item
                                        label="儿童价格"
                                        name="priceChild"
                                        rules={[{ required: true, message: 'Please input!' }]}
                                        labelCol={{ span: 12 }}
                                    >
                                        <InputNumber style={{ width: "100%" }} />
                                    </Form.Item>
                                </Col>
                            }
                        </Row>
                        <Row>
                            <Col span={12}>
                                <Form.Item
                                    label="出发城市"
                                    name="departureCity"
                                    rules={[{ required: true, message: 'Please select!' }]}
                                    labelCol={{ span: 8 }}
                                >
                                    <Select
                                        style={{ width: '100%' }}
                                    >
                                        <Option value="1">天气原因</Option>
                                        <Option value="2">行程有变</Option>
                                        <Option value="3">态度问题</Option>
                                    </Select>
                                </Form.Item>
                            </Col>
                            <Col span={12}>
                                <Form.Item
                                    label="资源所用城市"
                                    name="currentCity"
                                    rules={[{ required: true, message: 'Please select!' }]}
                                    labelCol={{ span: 8 }}
                                >
                                    <Select
                                        style={{ width: '100%' }}
                                    >
                                        <Option value="1">天气原因</Option>
                                        <Option value="2">行程有变</Option>
                                        <Option value="3">态度问题</Option>
                                    </Select>
                                </Form.Item>
                            </Col>
                            <Col span={24}>
                                <Form.Item
                                    label="SKU"
                                    name="sku"
                                    labelCol={{ span: 4 }}
                                    wrapperCol={{ span: 20 }}
                                >
                                    <Select
                                        showSearch={true}
                                        labelInValue
                                        value={this.state.value}
                                        placeholder="输入关键词查询"
                                        notFoundContent={this.state.fetching ? <Spin size="small" /> : null}
                                        filterOption={false}
                                        onSearch={this.fetchUser}
                                        style={{ width: '100%' }}
                                    >
                                        {this.state.data.map((d: { value: any, text: any }) => (
                                            <Option key={d.value} value={d.value}>{d.text}</Option>
                                        ))}
                                    </Select>
                                </Form.Item>
                            </Col>
                            <Col span={24}>
                                <Form.Item
                                    label="资源说明"
                                    name="intro"
                                    labelCol={{ span: 4 }}
                                    wrapperCol={{ span: 20 }}
                                >
                                    <TextArea rows={4}></TextArea>
                                </Form.Item>
                            </Col>
                        </Row>

                        <Divider />

                        <Form.Item>
                            <Row justify="center">
                                <Space size="large">
                                    <Button onClick={this.cancelModal}>取消</Button>
                                    <Button type="primary" htmlType="submit">确认提交</Button>
                                </Space>
                            </Row>
                        </Form.Item>
                    </Form>
                </Modal>
            </div>
        )
    }
}

export default ExtraEdit;